import { FC } from 'react';
import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';
import { CmsComponentProps } from '@/types/cms';
const DynamicSingleProduct = dynamic(() => import('./single-coupon'), {
  ssr: false,
  loading: Skeleton
});

const SingleCoupon: FC<CmsComponentProps> = ({ ...props }) => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });
  const skeleton = <Skeleton />;
  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }
  return <DynamicSingleProduct skeleton={skeleton} {...props} />;
};

export default SingleCoupon;
